import { render, staticRenderFns } from "./CasimirEffectViz.vue?vue&type=template&id=ca8b9798&scoped=true"
import script from "./CasimirEffectViz.vue?vue&type=script&lang=js"
export * from "./CasimirEffectViz.vue?vue&type=script&lang=js"
import style0 from "./CasimirEffectViz.vue?vue&type=style&index=0&id=ca8b9798&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8b9798",
  null
  
)

export default component.exports